import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { roleCheck } from "utils/index";
import { SURVEYORS } from "utils/constants";
import { getCurrentUser, getCurrentRole } from "../../../reducers";

const NavBar = () => {
  const currentUser = useSelector(getCurrentUser);
  const currentRole = useSelector(getCurrentRole);
  const systemRole = currentUser?.attributes?.role;
  const canAccessMyReimbursements = roleCheck(systemRole, currentRole, SURVEYORS);

  return (
    <ul className="nav flex-column">
      <li className="nav-item">
        <NavLink className="nav-link" to="/settings/account-settings">
          Account Settings
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" to="/settings/my-gear">
          My Assets
        </NavLink>
      </li>
      {canAccessMyReimbursements && (
        <li className="nav-item">
          <NavLink className="nav-link" to="/settings/my-reimbursements">
            My Reimbursements
          </NavLink>
        </li>
      )}
      <li className="nav-item">
        <a
          className="nav-link"
          href="https://aushare.sharepoint.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Company Intranet
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link"
          href="https://aushare.sharepoint.com/SitePages/Policies-and-Forms.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          Company Documents
        </a>
      </li>
    </ul>
  );
};

export default NavBar;
